import { useTranslation } from 'react-i18next';

export type ProfileTabKey = 'info' | 'access' | 'sessions';

export interface ProfileTabsProps {
    active: ProfileTabKey;
    onSelect: (tab: ProfileTabKey) => void;
    /** Session count badge next to "Phiên đăng nhập" (frames 77-79/82 all show it). */
    sessionCount?: number;
}

/**
 * EAA-1820: `/profile` tab bar — frames 77 (Thông tin), 78 (Quyền của tôi) and
 * 79 (Phiên đăng nhập) are three tabs of the SAME route, switched locally
 * (no `?tab=` in the captured frames, unlike `/console/permissions` — kept
 * as plain state rather than inventing a query-param convention the frames
 * don't show).
 */
export function ProfileTabs({ active, onSelect, sessionCount }: ProfileTabsProps) {
    const { t } = useTranslation();

    const tabs: { key: ProfileTabKey; label: string; count?: number }[] = [
        { key: 'info', label: t('profile.tabs.info') },
        { key: 'access', label: t('profile.tabs.access') },
        { key: 'sessions', label: t('profile.tabs.sessions'), count: sessionCount },
    ];

    return (
        <div className="portal-profile-tabs" role="tablist" aria-label={t('profile.pageTitle')}>
            {tabs.map((tab) => (
                <button
                    key={tab.key}
                    type="button"
                    role="tab"
                    aria-selected={active === tab.key}
                    className={
                        'portal-profile-tab' + (active === tab.key ? ' portal-profile-tab--on' : '')
                    }
                    onClick={() => onSelect(tab.key)}
                >
                    {tab.label}
                    {typeof tab.count === 'number' && (
                        <span className="portal-profile-tab-count">{tab.count}</span>
                    )}
                </button>
            ))}
        </div>
    );
}

export default ProfileTabs;
